export const HOME_PATH = '/';
export const ABOUT_PATH = 'about';
export const HELP_PATH = 'help';
export const OVERVIEW_PATH = 'overview';
export const COMPLETENESS_ERROR_PATH = 'repair-completeness-error';
export const ADHERENCE_ERROR_PATH = 'repair-adherence-error';
